import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { RedocStandalone } from "redoc";
import { Helmet } from "react-helmet";
import { DELTA_ACCENT, DELTA_PRIMARY, ENTERPRISE_TEAL, TEXT_SECONDARY } from "./colors";

// Public marketing/teaser page for the Company Directory API - no auth gate,
// no "try it out" console (Redoc has none, unlike Swagger UI). Purchasing
// happens from the Home page's API Access card, not here - Billing only
// manages a key you already have, so linking there would just bounce back.
export const ApiDocsPage = () => {
  return (
    <Box>
      <Helmet>
        <title>API Documentation | Company Directory | DeltaGain</title>
      </Helmet>

      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 16,
          padding: "24px 24px 0 24px",
        }}
      >
        <Box>
          <Typography variant="h4" style={{ color: DELTA_PRIMARY }}>
            Company Directory API
          </Typography>
          <Typography variant="body1" style={{ color: TEXT_SECONDARY, marginTop: 4 }}>
            Available as a self-serve add-on on API Pro and API Enterprise plans - subscribe to get a key instantly.
          </Typography>
        </Box>
        <Box style={{ display: "flex", gap: 8, flexShrink: 0 }}>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            style={{ backgroundColor: DELTA_ACCENT, color: "white" }}
          >
            Get an API Key
          </Button>
          <Button
            href="mailto:support@deltagain.co.uk?subject=Company%20Directory%20API"
            variant="outlined"
            style={{ borderColor: ENTERPRISE_TEAL, color: ENTERPRISE_TEAL }}
          >
            Contact Sales
          </Button>
        </Box>
      </Box>

      <Box style={{ marginTop: 16 }}>
        <RedocStandalone
          specUrl="/openapi.json"
          options={{
            hideDownloadButton: false,
            theme: {
              colors: {
                primary: { main: DELTA_PRIMARY },
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ApiDocsPage;
